import endpoints, { axios } from "../config/api";

async function getTaskTemplateDependancies(taskId: number) {
  return (
    await axios.get(endpoints.taskTemplates.getTaskTemplateDependancies(taskId))
  ).data;
}

export default getTaskTemplateDependancies;
